export function extractLocaleString(object, defaultLocale = "en") {
  return object[window.clientConfig.locale.toLowerCase()] || object[defaultLocale] || "";
}